import { AuthNotice } from '../components/AuthSplitLayout.tsx';
import { BRAND } from '../lib/brand.ts';

export function CompanyExpired() {
  return (
    <AuthNotice
      variant="vendor"
      title="Your session has ended"
      action={
        <a href="/c/login" className="font-semibold text-brand-primary hover:underline">
          Go to sign in
        </a>
      }
    >
      Your session has ended or your account is unavailable. Sign in again to continue, or contact{' '}
      <a
        href={`mailto:${BRAND.supportEmail}`}
        className="font-semibold text-brand-primary hover:underline"
      >
        {BRAND.supportEmail}
      </a>{' '}
      if you need help.
    </AuthNotice>
  );
}
